function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Resolutions } from '../../utils/resolution';
import { getSupportedFormats } from '../../utils/supported-formats';
import { matchPartialDeviceInformation } from '../../utils/device-information';
import { VideoFormat, VideoColourSpace } from './player.enums';
export { VideoFormat, VideoColourSpace, VideoCodec, HdcpLevel, WidevineSecurityLevel } from './player.enums';
export var RESOLUTION_540P = {
    width: 960,
    height: 540
};
export var RESOLUTION_576P = {
    width: 960,
    height: 576
};
export var RESOLUTION_720P = {
    width: 1280,
    height: 720
};
export var DEFAULT_VIDEO_FORMAT = VideoFormat.HD;
export var DEFAULT_FRAME_RATE = 30;
export var MIN_4K_HDCP_VERSION = '2.2';
export var MIN_HD_HDCP_VERSION = '1.0';
export function getMaxFrameRate(sessionItem, deviceInfo, compatibleStreamPropertyGroup) {
    var _Math;
    var _sessionItem_videoFormatConfig_deviceLimitationList, _sessionItem_videoFormatConfig, _sessionItem_videoFormatConfig_support, _sessionItem_videoFormatConfig1;
    var _sessionItem_videoFormatConfig_deviceLimitationList_filter_map;
    var deviceLimitationEntries = (_sessionItem_videoFormatConfig_deviceLimitationList_filter_map = (_sessionItem_videoFormatConfig = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig === void 0 ? void 0 : (_sessionItem_videoFormatConfig_deviceLimitationList = _sessionItem_videoFormatConfig.deviceLimitationList) === null || _sessionItem_videoFormatConfig_deviceLimitationList === void 0 ? void 0 : _sessionItem_videoFormatConfig_deviceLimitationList.filter(function(entry) {
        return matchPartialDeviceInformation(entry.device, deviceInfo);
    }).map(function(entry) {
        return entry.support.maxFrameRate;
    })) !== null && _sessionItem_videoFormatConfig_deviceLimitationList_filter_map !== void 0 ? _sessionItem_videoFormatConfig_deviceLimitationList_filter_map : [];
    var formatLimitations = _to_consumable_array(deviceLimitationEntries).concat([
        compatibleStreamPropertyGroup === null || compatibleStreamPropertyGroup === void 0 ? void 0 : compatibleStreamPropertyGroup.maxFrameRate,
        (_sessionItem_videoFormatConfig1 = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig1 === void 0 ? void 0 : (_sessionItem_videoFormatConfig_support = _sessionItem_videoFormatConfig1.support) === null || _sessionItem_videoFormatConfig_support === void 0 ? void 0 : _sessionItem_videoFormatConfig_support.maxFrameRate
    ]).filter(function(format) {
        return format !== undefined && format !== null;
    });
    return formatLimitations.length > 0 ? (_Math = Math).min.apply(_Math, _to_consumable_array(formatLimitations)) : DEFAULT_FRAME_RATE;
}
export function getMaxVideoFormat(sessionItem, deviceInfo, compatibleStreamPropertyGroup) {
    var _Math;
    var _sessionItem_videoFormatConfig_deviceLimitationList, _sessionItem_videoFormatConfig, _sessionItem_videoFormatConfig_support, _sessionItem_videoFormatConfig1;
    var _sessionItem_videoFormatConfig_deviceLimitationList_filter_map;
    var deviceLimitationEntries = (_sessionItem_videoFormatConfig_deviceLimitationList_filter_map = (_sessionItem_videoFormatConfig = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig === void 0 ? void 0 : (_sessionItem_videoFormatConfig_deviceLimitationList = _sessionItem_videoFormatConfig.deviceLimitationList) === null || _sessionItem_videoFormatConfig_deviceLimitationList === void 0 ? void 0 : _sessionItem_videoFormatConfig_deviceLimitationList.filter(function(entry) {
        return matchPartialDeviceInformation(entry.device, deviceInfo);
    }).map(function(entry) {
        return entry.support.maxVideoFormat;
    })) !== null && _sessionItem_videoFormatConfig_deviceLimitationList_filter_map !== void 0 ? _sessionItem_videoFormatConfig_deviceLimitationList_filter_map : [];
    var formatLimitations = _to_consumable_array(deviceLimitationEntries).concat([
        compatibleStreamPropertyGroup === null || compatibleStreamPropertyGroup === void 0 ? void 0 : compatibleStreamPropertyGroup.maxVideoFormat,
        (_sessionItem_videoFormatConfig1 = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig1 === void 0 ? void 0 : (_sessionItem_videoFormatConfig_support = _sessionItem_videoFormatConfig1.support) === null || _sessionItem_videoFormatConfig_support === void 0 ? void 0 : _sessionItem_videoFormatConfig_support.maxVideoFormat
    ]).filter(function(format) {
        return format !== undefined && format !== null;
    });
    return formatLimitations.length > 0 ? (_Math = Math).min.apply(_Math, _to_consumable_array(formatLimitations)) : DEFAULT_VIDEO_FORMAT;
}
export function getVideoFormatFromResolution(res) {
    if (res.width >= Resolutions.UHD.minWidth && res.height >= Resolutions.UHD.minHeight) {
        return VideoFormat.UHD;
    } else if (res.width >= Resolutions.HD.minWidth && res.height >= Resolutions.HD.minHeight) {
        return VideoFormat.HD;
    }
    return VideoFormat.SD;
}
export function getSupportedColourSpaces(sessionItem, deviceInfo, compatibleStreamPropertyGroup) {
    var _sessionItem_videoFormatConfig_deviceLimitationList, _sessionItem_videoFormatConfig, _sessionItem_videoFormatConfig_support, _sessionItem_videoFormatConfig1;
    var deviceLimitationEntries = (_sessionItem_videoFormatConfig = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig === void 0 ? void 0 : (_sessionItem_videoFormatConfig_deviceLimitationList = _sessionItem_videoFormatConfig.deviceLimitationList) === null || _sessionItem_videoFormatConfig_deviceLimitationList === void 0 ? void 0 : _sessionItem_videoFormatConfig_deviceLimitationList.filter(function(entry) {
        return matchPartialDeviceInformation(entry.device, deviceInfo) && entry.support.supportedColourSpaces && entry.support.supportedColourSpaces.length > 0;
    });
    var deviceLimitations = deviceLimitationEntries === null || deviceLimitationEntries === void 0 ? void 0 : deviceLimitationEntries.map(function(entry) {
        return entry.support.supportedColourSpaces;
    });
    return getSupportedFormats((compatibleStreamPropertyGroup === null || compatibleStreamPropertyGroup === void 0 ? void 0 : compatibleStreamPropertyGroup.supportedColourSpaces) || [
        VideoColourSpace.SDR
    ], (_sessionItem_videoFormatConfig1 = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig1 === void 0 ? void 0 : (_sessionItem_videoFormatConfig_support = _sessionItem_videoFormatConfig1.support) === null || _sessionItem_videoFormatConfig_support === void 0 ? void 0 : _sessionItem_videoFormatConfig_support.supportedColourSpaces, deviceLimitations);
}

//# sourceMappingURL=video-format.js.map